import { IActivateSegmentOffer, ISegmentOffer, ITDSAbsorptionOfferRawData } from './type';

export const hydrateFormData = (data: ISegmentOffer): ITDSAbsorptionOfferRawData => {
	const hydratedData: ITDSAbsorptionOfferRawData = {} as ITDSAbsorptionOfferRawData;
	hydratedData.segmentName = data.segmentName;
	hydratedData.bucketName = data.bucketName;
	hydratedData.absorptionAmountLimit = data.absorptionAmountLimit;
	hydratedData.absorptionTransactionLimit = data.absorptionTransactionLimit;
	hydratedData.isActive = data.isActive;
	return hydratedData;
};

export const dehydrateFormData = (data: ITDSAbsorptionOfferRawData): IActivateSegmentOffer => {
	const tdsOffer: IActivateSegmentOffer = {} as IActivateSegmentOffer;
	tdsOffer.segmentName = data.segmentName;
	tdsOffer.isActive = data.isActive;
	tdsOffer.bucketName = data.bucketName;
	tdsOffer.absorptionAmountLimit = data.absorptionAmountLimit;
	tdsOffer.absorptionTransactionLimit = data.absorptionTransactionLimit;
	tdsOffer.segmentType = data.segmentType;
	return tdsOffer;
};
